import FooterComponent from './FooterComponent.jsx';
import './FooterComponent.less';

export default FooterComponent;
